<section class="container mt-5">
    <h2 class="tituloEventos">Todas las ciudades</h2>
    <div *ngIf ='message' class="alert alert-success ">{{message}}</div>
    <div class="row">
        <div class="col-12 mt-5 btnAdd" style="text-align: center;">
            <button  routerLink="agregar" class="btn btn-primary">Agregar Ciudad</button>
        </div>
    </div>
    <div class="container containerTabla">
        <table class="table mt-3 contenedorLista">
            <thead>
                <tr>
                    <th>Id</th>
                    <th>Nombre</th>
                    <th>Temperatura</th>
                    <th class="v-desktop">Foto</th>
                    <th class="v-desktop">Modificar</th>
                    <th class="v-desktop">Borrar</th> 
                    <th class="v-mobile">Opciones</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor = "let ciudad of ciudades" class="filasEventos">
                    <td>{{ciudad?.id}}</td>
                    <td>{{ciudad?.nombre }}</td>
                    <td>{{ciudad?.temperatura}}</td>
                    <td class="v-desktop max-lg"><button class="btn btn-success" (click)="AgregarFotoCiudad(ciudad)">Agregar Foto De Ciudad</button></td>
                    <td class="v-desktop"><button routerLink="update/{{ciudad.id}}" class="btn btn-warning">  Modificar</button></td>
                    <td class="v-desktop"><button  class="btn btn-danger" (click)="deleteCiudad(ciudad.id)" > Delete</button></td>
                    <td class="options v-mobile">
                        <a (click)="AgregarFotoCiudad(ciudad)"><mat-icon>add_a_photo</mat-icon></a>
                        <a routerLink="update/{{ciudad.id}}"><mat-icon>mode</mat-icon></a>
                        <a (click)="deleteCiudad(ciudad.id)" ><mat-icon>delete</mat-icon></a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</section>